module.exports = __webpack_public_path__ + "img/wicked-report.601e70e2.jpg";